// Importing the language module for the 'en' locale
import en from "./en";

// Combining language modules for different locales into a single 'lang' object
const lang = {
  en: en(),
};

// Function to retrieve the language module based on the specified type (default is 'en')
export default function getLang(type = "en") {
  return lang[type];
}
